// extracted by mini-css-extract-plugin
export default {"InnerHTML":"styles_InnerHTML__3Fj9F"};